import { render, staticRenderFns } from "./loading-link.vue?vue&type=template&id=547070c4&scoped=true&"
import script from "./loading-link.vue?vue&type=script&lang=js&"
export * from "./loading-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547070c4",
  null
  
)

export default component.exports